import React, { useState } from "react";
import personaServicio from "../services/persona/personaServicio";
import { IComboBoxOption } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { IEquipoTrabajoByPersonaId } from "../Interfaces/IPersona";

export const useDetallePersona = () => {
  
  const [nombreSupervisor, setNombreSupervisor] = useState<string | undefined>();
  const [supervisoresCombo, setSupervisoresCombo] = useState<IComboBoxOption[]>([]);
  
  const DataInfoSupervisor = (id: string) => {
    if (id != undefined) {
      personaServicio
        .supervisorPorPersonaId(id)
        .then((res) => {
          if (res.status === 200) {
            var perAux: IEquipoTrabajoByPersonaId[] = res.data;
            if (perAux.length > 0)
              setNombreSupervisor(perAux[0].reportaPersona);
          }
        })
        .catch((e: Error) => {
          console.log(e.message);
        });
    }
  };

  const getDataListSupervisores = () => {
    personaServicio
      .getSupervisoresIPERCdigital("")
      .then((res) => {
        let d: any[] = res.data;
        let op: IComboBoxOption[] = [];
        d.map((val) => {
          op.push({
            key: val.supervisorId,
            text: val.doi + " | " + val.fullName,
          });
        });
        setSupervisoresCombo(op);
      })
      .catch((e: Error) => {});
  };
  return {
    DataInfoSupervisor,
    nombreSupervisor,
    getDataListSupervisores,
    supervisoresCombo,
  };
};
